import { Route, Routes, useLocation } from "react-router-dom";
import "./App.css";
import HomePage from "./pages/HomePage";
import NavBar from "./components/nav/NavBar";
import Drawer from "./components/nav/Drawer";
import Footer from "./components/nav/Footer";
import utils from "./utils";
import { Toaster } from "react-hot-toast";
import AboutPage from "./pages/AboutPage";
import ContactPage from "./pages/ContactPage";
import LoginPage from "./pages/auth/LoginPage";
import RegisterPage from "./pages/auth/RegisterPage";
import ForgotPasswordPage from "./pages/auth/ForgotPassowrd";
import NursesListPage from "./pages/nurses/NursesListPage";
import PatientsListPage from "./pages/patients/PatientsListPage";
import RequestsListPage from "./pages/requests/RequestsListPage";
import NurseViewPage from "./pages/nurses/NurseViewPage";
import PatientViewPage from "./pages/patients/PatientViewPage";
import PageNotFound from "./pages/PageNotFound";
import RequestViewPage from "./pages/requests/RequestViewPage";
import AdminDashboardPage from "./pages/dashboard/AdminDashboardPage";
import ServicesPage from "./pages/ServicesPage";
import TermsPage from "./pages/TermsPage";
import PrivacyPage from "./pages/PrivacyPage";
import SettingsPage from "./pages/auth/SettingsPage";
import ProtectedRoutes from "./LoggedInReroutes";
import ServiesAdminPage from "./pages/dashboard/ServiesAdminPage";
import DataInitializer from "./components/nav/SessionInit";
import { useEffect } from "react";
import PaymentsListPage from "./pages/payments/PaymentsListPage";
import HelpPage from "./pages/HelpPage";

function App(props) {
  const location = useLocation()
  useEffect(() => {
    const topNav = document.getElementById("nav-top")
    if (topNav) topNav.scrollIntoView({ behavior: 'smooth' });
  }, [location])
  return (
    <div className="App">
      <DataInitializer/>
      <div className="">
        <div className="drawer lg:drawer-open">
          <input id="nav-drawer" type="checkbox" className="drawer-toggle" />
          <div className="drawer-content">
            <div id="nav-top" className=""></div>
            <NavBar />
            <div className="page">
              <Routes>
                <Route path="/" element={<HomePage />} />
                <Route path="/about" element={<AboutPage />} />
                <Route path="/help" element={<HelpPage />} />
                <Route path="/contact" element={<ContactPage />} />
                <Route path="/services" element={<ServicesPage />} />
                <Route path="/privacy" element={<PrivacyPage />} />
                <Route path="/terms" element={<TermsPage />} />

                <Route path="/auth/login" element={<LoginPage />} />
                <Route path="/auth/forgot" element={<ForgotPasswordPage />} />
                <Route path="/auth/register" element={<RegisterPage />} />

                <Route
                  path="/admin/dashboard"
                  element={
                    <ProtectedRoutes>
                      <AdminDashboardPage />
                    </ProtectedRoutes>
                  }
                />

                <Route
                  path="/auth/settings"
                  element={
                    <ProtectedRoutes>
                      <SettingsPage />
                    </ProtectedRoutes>
                  }
                />

                <Route
                  path="/dashboard/services"
                  element={
                    <ProtectedRoutes>
                      <ServiesAdminPage />
                    </ProtectedRoutes>
                  }
                />

                <Route
                  path="/dashboard/nurses"
                  element={
                    <ProtectedRoutes>
                      <NursesListPage />
                    </ProtectedRoutes>
                  }
                />
                <Route
                  path="/nurse/:id"
                  element={
                    <ProtectedRoutes>
                      <NurseViewPage />
                    </ProtectedRoutes>
                  }
                />

                <Route
                  path="/dashboard/patients"
                  element={
                    <ProtectedRoutes>
                      <PatientsListPage />
                    </ProtectedRoutes>
                  }
                />
                <Route
                  path="/patient/:id"
                  element={
                    <ProtectedRoutes>
                      <PatientViewPage />
                    </ProtectedRoutes>
                  }
                />

                <Route
                  path="/dashboard/requests"
                  element={
                    <ProtectedRoutes>
                      <RequestsListPage />
                    </ProtectedRoutes>
                  }
                />
                <Route
                  path="/request/:id"
                  element={
                    <ProtectedRoutes>
                      <RequestViewPage />
                    </ProtectedRoutes>
                  }
                />
                <Route
                  path="/dashboard/payments"
                  element={
                    <ProtectedRoutes>
                      <PaymentsListPage />
                    </ProtectedRoutes>
                  }
                />

                <Route path="*" element={<PageNotFound />} />
              </Routes>
            </div>
            <Footer />
            <Toaster
              position={utils.toasterPosition}
              toastOptions={utils.toasterOptions}
            />
          </div>
          <Drawer key={location.pathname} />
        </div>
      </div>
    </div>
  );
}

export default App;
